module.exports = "/images/icon-pause.svg?23f22d2cf3b6914e9704e4548934ee58";